<template>
  <div>
    <loading :showLoading="load" />
    <grid
      class="grid"
      :title="$t('PODGrid.Title')"
      :headers="headers"
      controller
      readAll="POD/GetPODs"
      :disableEdit="true"
      :disableDelete="true"
      :ExportExcel="true"
      :ShowMenu="true"
      :CanCreate="false"
      :CanDownload="canDownloadPod"
      :externalFilters="this.$store.getters.GET_elementToSearchOfGridMenu"
      searchFields="ClientCode,ShipmentCode,FileName,ShipmentDate"
      controllerEdit="ResultDetail"
      edit="Detail"
      :refresh="this.$store.getters.GET_reloadPage"
      :showFooter="false"
      :CounterColumns="['fileName']"
      :hideColumns="[ 'archiveDate', 'creationDate', 'creationUser', 'id', 'idPOD', 'lastDownloadDate', 'lastModifyDate',
      'lastModifyUser', 'logicDeleteDate','logicDeleteUser','repoCode','shipmentDate','storage','weight','widthxHeight']"
      gridType="PODSearch"
      v-on:download="gridDownload"
      v-on:podPreview="podPreview"
    >
      <template v-slot:default="child">
        <li
          @click="preview(child.child.data.name)"
          class="li-nobullets contextMenu"
        >
          <span>{{ $t('ContextMenu.Preview') }}</span>
        </li>
        <!-- <li @click="downloadZip([child.child.data.name], true)" class="li-nobullets contextMenu">          
          <span>{{ $t('ContextMenu.Download') }}</span>
        </li> -->
        <!-- <li @click="edit(child)" class="li-nobullets">
          <i class="fas fa-edit" />
          <span>{{ $t('ContextMenu.Attachments') }}</span>
        </li> -->
      </template>
    </grid>

    <v-dialog
      v-model="dialog"
      content-class="Image-Container-Style"
    >
      <preview :images="podImages" class="Image-Box-Style"></preview>
    </v-dialog>

    <v-snackbar
      v-model="showErr"
      color="error"
    >
      {{ textErr }}
      <v-btn
        color="white"
        text
        @click="showErr=false"
      >
        {{ $t("Misc.Close") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import loading from "../../components/loadingComponent.vue";
import grid from "../../components/gridComponent.vue";
import preview from "../../components/previewComponent.vue";
import router from "@/router/index.js";
import { Trans } from "@/plugins/Translation";
import HyperstorageApi from "../../api/Hyperstorage/api.js";
import PODApi from "../../api/PODPortal/api.js";

export default {
  components: {
    loading,
    grid,
    preview    
  },

  data() {
    return {
      load: false,
      refresh: false,
      refreshWatch: false,
      filters: {},
      dialog: false,
      pods_guid: [],
      showErr: false,
      textErr: "",
      canDownloadPod: false,
      localStorageItemGridId: "podportal_savedSearchParamsGrid",
      headers: [
        { text: Trans.i18n.t("grid.Columns.ClientCode"), value: "clientCode" },
        { text: Trans.i18n.t("grid.Columns.SenderCode"), value: "senderCode" },
        { text: Trans.i18n.t("grid.Columns.RecipientCode"), value: "recipientCode" },
        {
          text: Trans.i18n.t("grid.Columns.ShipmentCode"),
          value: "shipmentCode"
        },
        {
          text: Trans.i18n.t("grid.Columns.ShipmentDate"),
          value: "shipmentDate_s"
        },
        { text: Trans.i18n.t("grid.Columns.DocsNumber"), value: "docs" },
        { text: Trans.i18n.t("grid.Columns.CreationDate"), value: "creationDate" }       
      ],
      podImages: []
    };
  },

  watch: {},

  created() {
    this.menuStart();
    this.filters = JSON.parse(
      localStorage.getItem(this.localStorageItemGridId)
    );

    var lolSFilter = JSON.parse(localStorage.getItem("FullTextWithLike"));
      if(lolSFilter)
        localStorage.removeItem("FullTextWithLike")
        
    this.$store.commit("SET_elementToSearchOfGridMenu", this.filters);

    this.$GAUserAuth.canRead(process.env.VUE_APP_DOWNLOAD_POD).then(r => {
        //console.log("can download pod", r);
        this.canDownloadPod = r;
      });
  },

  methods: {
    podPreview(item) { 
      //console.log("index pod preview", item);
      this.preview(item);
    },

    gridDownload(type) {

      //console.log("grid download", type);      
      
      this.load = true;

      // consider all the pods
      let new_filters = this.$store.getters.GET_elementToSearchOfGridMenu.filter(
        function(obj) {
          return obj.Field !== "FileName";
        }
      );

      let filters = {
        sortBy: [],
        descending: false,
        page: 1,
        rowsPerPage: 10000,
        CounterColumns: [],
        filters: new_filters
      };

      var lolSFilter = JSON.parse(localStorage.getItem("FullTextWithLike"));
      if(lolSFilter)
        filters.filters.push(lolSFilter);
        
      if (type=="jpg") {
          PODApi.GetPODs(filters)
            .then(res => {
              this.downloadZip(res.data.items, false).catch(e => {
                this.showErr = true;
                this.textErr = e.response;
                this.load = false;
              });
            })
            .catch(e => {
              this.showErr = true;
              this.textErr = e.response.data;
              this.load = false;
            });
      }
      // pdf
      else {
          HyperstorageApi.GetPODPdfZip(filters)
            .then(res => {
              //console.log("res", res);
              var byteArray = new Uint8Array(res.data);
              var a = window.document.createElement("a");
              a.href = window.URL.createObjectURL(
                new Blob([res.data], { type: "application/octet-stream" })
              );
              a.download = "PODs.zip";
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              this.load = false;   
            })
            .catch(e => {
              this.showErr = true;
              this.textErr = e.response.data;
              this.load = false;
            });
      }
    },

    async downloadZip(guids, getAttachments) {
      
        this.pods_guid = [];
        this.load = true;
      
        if (getAttachments) {
          for (let element in guids) {
            this.pods_guid.push(guids[element]);
            //let data = this.GetFilter(guids[element].shipmentCode);
            //let res = await HyperstorageApi.GetPOD(data);
            let res = await HyperstorageApi.GetAdditionalDocument(guids[element].shipmentCode);
            //this.pods_guid.push(...res.data.items);
            this.pods_guid.push(...res.data);
          }
        } else {
          this.pods_guid = guids;
        }

        //console.log("downloadZipdone end", this.pods_guid,  this.pods_guid.map(a => a.id));

        let zip = await HyperstorageApi.GetPODZip(this.pods_guid.map(a => a.id));
        var byteArray = new Uint8Array(zip.data);
        var a = window.document.createElement("a");
        a.href = window.URL.createObjectURL(
          new Blob([zip.data], { type: "application/octet-stream" })
        );
        a.download = "PODs.zip";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        this.load = false;      
    },

    async preview(child) {
      this.podImages = [];
      this.load = true;
    
      //let data = this.GetFilter(child.child.data.name.shipmentCode);
      HyperstorageApi.GetAdditionalDocument(child.shipmentCode)
        .then(res => {
          //this.childItems = res.data.items;
          //console.log("items", res.data);
          this.childItems = res.data;

          this.childItems.forEach(element => {
            HyperstorageApi.GetImage(element.id).then(res => {
              var b = Buffer.from(res.data, "binary").toString("base64");
              var src_image =
                "data:" + res.headers["content-type"] + ";base64," + b;
              this.podImages.push({ src: src_image, idPOD: element.idPOD });

              this.podImages = this.podImages.sort(function(a, b) { 
                return a.idPOD - b.idPOD;
              });
            });
          });
        })
        .catch(e => {
          this.showErr = true;
          this.textErr = e.response.data;
          this.load = false;
        });

        PODApi.GetImage(child.id).then(res => {              
          this.podImages = this.podImages.sort(function(a, b) { 
            return a.idPOD - b.idPOD;
          });

          var b = Buffer.from(res.data, "binary").toString("base64");
          var src_image = "data:" + res.headers["content-type"] + ";base64," + b;
          this.podImages.unshift({ src: src_image });

          this.load = false;
          this.dialog = !this.dialog;
        })
        .catch(e => {
          this.showErr = true;
          this.textErr = e.response.data;
          this.load = false;
        });
    },

    async asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    },

    GetFilter(shipmentCode) {
      let data = {
        SortBy: [],
        CounterColumns: [],
        Descending: false,
        Page: 1,
        RowsPerPage: 10000,
        Filters: [
          {
            Field: "FileName",
            Filtervalue: "`_",
            FilterType: "Contains"
          },
          {
            Field: "ShipmentCode",
            Filtervalue: shipmentCode,
            FilterType: "Contains"
          }
        ]
      };
      return data;
    },

    menuStart() {
      let showSM = {
        show: false,
        style: "color: #cecece;"
      };
      this.$store.commit("SET_showSearchMenu", showSM);
    },

    edit(child) {
      //router.push({name: "ResultDetail", params: { Id: child.child.data.name.idSped} });
    },
  }
};
</script>
